/* ============================================================================
   RK SCHIENE — Pfeile für die wischbare Produktreihe
   Ein Klick schiebt um fast eine Bildschirmbreite weiter. Die Pfeile werden
   blass, wenn es in die Richtung nicht weitergeht.
   Powered by René Kress - Crovio · www.crovio.de
   ========================================================================= */
(function () {
  'use strict';

  function einrichten(sch) {
    if (sch.hasAttribute('data-rk-sch-bereit')) return;
    sch.setAttribute('data-rk-sch-bereit', '1');

    var reihe = sch.querySelector('[data-rk-sch-reihe]');
    var zurueck = sch.querySelector('[data-rk-sch-zurueck]');
    var weiter = sch.querySelector('[data-rk-sch-weiter]');
    if (!reihe || !zurueck || !weiter) return;

    function stand() {
      var max = reihe.scrollWidth - reihe.clientWidth - 2;
      zurueck.disabled = reihe.scrollLeft <= 2;
      weiter.disabled = reihe.scrollLeft >= max;
    }

    function schieben(richtung) {
      reihe.scrollBy({ left: richtung * reihe.clientWidth * 0.8, behavior: 'smooth' });
    }

    zurueck.addEventListener('click', function () { schieben(-1); });
    weiter.addEventListener('click', function () { schieben(1); });
    reihe.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand, { passive: true });
    stand();
  }

  function alle() { document.querySelectorAll('[data-rk-sch]').forEach(einrichten); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }
  document.addEventListener('shopify:section:load', alle);
})();
